import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-asset-partner",
	templateUrl: "./asset-partner.component.html",
	styleUrls: ["./asset-partner.component.scss"],
	imports: [ActionButtonComponent, FormsModule]
})
export class AssetPartnerComponent implements OnInit {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.Asset;

	public assetPartners: APIResults.Organization[];
	public assetPotentialPartners: APIResults.Organization[];
	public addPartnerOrg: APIResults.Organization;

	async ngOnInit(): Promise<void> {
		await this.RefreshData();
	}

	async RefreshData(): Promise<void> {
		const [organizations, assetPartners] = await Promise.all([
			this.api.GetOrganizations(),
			this.api.GetAssetPartners(this.asset.asset_id)
		]);
		this.assetPartners = assetPartners;
		this.assetPotentialPartners = organizations.filter(item => item.organization_id !== this.asset.organization_id && !this.assetPartners.some(partner => partner.organization_id === item.organization_id));
	}

	public async AddPartner() {
		await this.api.AddAssetPartner(this.asset.asset_id, this.addPartnerOrg.organization_id);
		await this.RefreshData();
	}
	public async DeletePartner(organization_id: number) {
		await this.api.DeleteAssetPartner(this.asset.asset_id, organization_id);
		await this.RefreshData();
	}
}
